import { render } from "./BlockBrands.vue?vue&type=template&id=06dee32c&scoped=true"
import script from "./BlockBrands.vue?vue&type=script&lang=js"
export * from "./BlockBrands.vue?vue&type=script&lang=js"

import "./BlockBrands.vue?vue&type=style&index=0&id=06dee32c&scoped=true&lang=css"

import exportComponent from "/mnt/dados/Projects/AcivgTheme/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06dee32c"]])

export default __exports__